import { render, staticRenderFns } from "./Form1_PersonaInversor.vue?vue&type=template&id=df2c5baa"
import script from "./Form1_PersonaInversor.vue?vue&type=script&lang=js"
export * from "./Form1_PersonaInversor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df2c5baa')) {
      api.createRecord('df2c5baa', component.options)
    } else {
      api.reload('df2c5baa', component.options)
    }
    module.hot.accept("./Form1_PersonaInversor.vue?vue&type=template&id=df2c5baa", function () {
      api.rerender('df2c5baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios1/HIPOTECALO/Form1_PersonaInversor.vue"
export default component.exports